import { useState } from "react";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../lib/firebase";
import { crmShellLoginCallable } from "../lib/crmApi";
import { CRM_OPERATORS } from "../lib/crmUsers";
import BrandLogo from "../components/BrandLogo";

export default function Login() {
  const [email, setEmail] = useState(CRM_OPERATORS[0].email);
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const fn = crmShellLoginCallable();
      const res = await fn({ email: email.trim().toLowerCase(), password });
      const token = res.data?.token;
      if (!token) throw new Error("No token returned");
      await signInWithCustomToken(auth, token);
    } catch (e) {
      const msg = e?.message || String(e);
      const code = e?.code || "";
      if (code === "functions/failed-precondition") {
        setErr("Server is not configured for CRM login. Deploy the crm Cloud Functions.");
      } else {
        setErr(msg.includes("permission-denied") ? "Invalid email or password." : msg);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="card login-card">
        <div className="login-brand">
          <BrandLogo className="logo-mark" width={48} height={48} />
          <div>
            <div className="login-title">Scanbrix CRM</div>
            <div className="login-sub">Sign in to continue</div>
          </div>
        </div>
        <form onSubmit={onSubmit}>
          <div style={{ fontSize: 11, color: "var(--text-3)", marginBottom: 4 }}>Email</div>
          <select className="select" style={{ width: "100%", marginBottom: 14 }} value={email} onChange={(e) => setEmail(e.target.value)}>
            {CRM_OPERATORS.map((o) => (
              <option key={o.email} value={o.email}>
                {o.name} · {o.email}
              </option>
            ))}
          </select>
          <div style={{ fontSize: 11, color: "var(--text-3)", marginBottom: 4 }}>Password</div>
          <input
            className="input"
            type="password"
            style={{ width: "100%", marginBottom: 16 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          {err ? (
            <div style={{ color: "var(--red)", fontSize: 13, marginBottom: 12 }}>{err}</div>
          ) : null}
          <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
